import * as Common from '@/agiles/common';
import { ModelBinder } from '../common/modelBinder';

export class UploadFile extends Common.ObjectBase{
    constructor(){
        super('UploadFile');
    }
    public id: number = 0;
    public parentKey:string = '';
    public parentId:string='';
    public fileName: string = '';
    public fileTimeStamp: Date;
    public fileSize: number =0;
    public uploadPIC: string = '';
    public uploadTimeStamp: Date = new Date();
    public description:string='';
    public contentType: string = '';
    public tag:string = null;
    public isAdmin:boolean = false;
    public get fileSizeKB() {return this.fileSize /1024;}

    public isTarget: boolean = false;   // クライアント側、UploadFileの対象選択用
}


export class UploadFileQuery extends Common.Query {
    constructor(){
        super('UploadFileQuery', new Common.ModelBinder(UploadFile,true))
    }
    public parentKey:string = '';
    public parentId:string='';    
    public isAdmin: boolean = false;    
}
/**添付ファイルをアップロードします */
export class UploadFileUploadQuery extends Common.Query {
    constructor(){
        super('UploadFileUploadQuery', new Common.ModelBinder(UploadFile,true))
    }
    public parentKey:string = '';
    public parentId:string='';    
    public timestamps :string='';
    public description:string='';
    public tag:string = null;
    public uploadPIC:string='';
}

export class UploadFileDownloadQuery extends Common.Query {
    constructor(){
        super('UploadFileDownloadQuery', null)
    }
    public uploadFile: UploadFile = null;
}